'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ramda = require('ramda');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function isEmptyNode(node) {
  return (0, _ramda.isEmpty)(node.children) && (0, _ramda.isEmpty)(node.values);
}

// https://en.wikipedia.org/wiki/Trie

var Trie = function () {
  function Trie() {
    _classCallCheck(this, Trie);

    this.tree = {
      children: {},
      values: []
    };
  }

  _createClass(Trie, [{
    key: 'at',
    value: function at(path) {
      return (0, _ramda.reduce)(function (node, p) {
        if (node && node.children[p]) {
          return node.children[p];
        } else {
          return undefined;
        }
      }, this.tree, path);
    }
  }, {
    key: 'has',
    value: function has(path) {
      return this.at(path) !== undefined;
    }
  }, {
    key: 'getValues',
    value: function getValues(path) {
      var nodeAtPath = this.at(path);

      return nodeAtPath && nodeAtPath.values;
    }
  }, {
    key: 'valuesInPath',
    value: function valuesInPath(path) {
      var result = (0, _ramda.reduce)(function (_ref, p) {
        var node = _ref.node,
            visitedPath = _ref.visitedPath,
            valuesInPath = _ref.valuesInPath;

        if (node && (0, _ramda.has)(p, node.children)) {
          var child = node.children[p];
          var currentPath = (0, _ramda.append)(p, visitedPath);

          return {
            node: child,
            visitedPath: currentPath,
            valuesInPath: (0, _ramda.ifElse)(_ramda.isEmpty, (0, _ramda.always)(valuesInPath), (0, _ramda.pipe)((0, _ramda.map)(function (value) {
              return { path: currentPath, value: value };
            }), (0, _ramda.concat)(valuesInPath)))(child.values)
          };
        } else {
          return { node: node, visitedPath: visitedPath, valuesInPath: valuesInPath };
        }
      }, {
        node: this.tree,
        visitedPath: [],
        valuesInPath: (0, _ramda.map)(function (value) {
          return { path: [], value: value };
        }, this.tree.values)
      }, path);

      return result.valuesInPath;
    }
  }, {
    key: 'add',
    value: function add(path, item) {
      var currentNode = this.tree;

      // create missing nodes along the way
      path.forEach(function (p) {
        if (!currentNode.children[p]) {
          currentNode.children[p] = {
            children: {},
            values: []
          };
        }

        currentNode = currentNode.children[p];
      });

      currentNode.values = (0, _ramda.append)(item, currentNode.values);
    }
  }, {
    key: 'remove',
    value: function remove(path, item) {
      var currentNode = this.tree;
      var parentStack = [];

      path.forEach(function (p) {
        if (!currentNode.children[p]) {
          throw new Error('Cannot find given item at given path');
        }

        parentStack.push({
          node: currentNode,
          childKey: p
        });

        currentNode = currentNode.children[p];
      });

      if (!(0, _ramda.contains)(item, currentNode.values)) {
        throw new Error('Cannot find given item at given path');
      }

      currentNode.values = (0, _ramda.reject)(function (v) {
        return v === item;
      }, currentNode.values);

      // remove empty nodes
      // to avoid memory leak
      while (parentStack.length > 0) {
        var _parentStack$pop = parentStack.pop(),
            node = _parentStack$pop.node,
            childKey = _parentStack$pop.childKey;

        if (!isEmptyNode(node.children[childKey])) {
          break;
        }

        delete node.children[childKey];
      }
    }
  }]);

  return Trie;
}();

exports.default = Trie;